// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v2.users.properties.floorplans.RentalManagerUserPropertyFloorPlanDeleteV2WebApiHandler

import type { UseMutationOptions } from '@zg-rentals/react-query5';
import { useMutation } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import { RentalManagerUserPropertyFloorPlanDeleteV2WebApiHandler_delete } from '@zg-rentals/ts-rental-manager-api-client';

import type { UserPropertyFloorPlanDeleteV2RequestDto } from '@zg-rentals/ts-rental-manager-api-client';

export interface RentalManagerUserPropertyFloorPlanDeleteV2WebApiHandler_delete_Args {
  postData: UserPropertyFloorPlanDeleteV2RequestDto;
}

export type RentalManagerUserPropertyFloorPlanDeleteV2WebApiHandler_delete_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyFloorPlanDeleteV2WebApiHandler_delete_Args
>;

/**
 * Delete floor plan of a property
 */
export const useRentalManagerUserPropertyFloorPlanDeleteV2WebApiHandler_delete = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyFloorPlanDeleteV2WebApiHandler_delete_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyFloorPlanDeleteV2WebApiHandler_delete_Args) =>
      RentalManagerUserPropertyFloorPlanDeleteV2WebApiHandler_delete(args.postData, httpClient),
  });
};
